export default __webpack_public_path__ + "static/media/untouchable.7b9fefe3.jpg";